// hooks/usePais.js
import { useState, useEffect } from 'react';

const CACHE_DURATION_MS = 30 * 60 * 1000; // 30 minutos
//30 * 60 * 1000
export const usePais = () => {
  const [esCuba, setEsCuba] = useState(null);
  const [errorGeo, setErrorGeo] = useState(null);

  useEffect(() => {
    const detectarPais = async () => {
      try {
        // 1. Leer caché
        const cachedValue = localStorage.getItem('esCuba');
        const cachedTimestamp = localStorage.getItem('esCuba_timestamp');

        if (cachedValue !== null && cachedTimestamp !== null) {
          const now = Date.now();
          const age = now - Number(cachedTimestamp);

          if (age <= CACHE_DURATION_MS) {
            setEsCuba(cachedValue === 'true');
            return;
          } else {
            // Opcional: limpiar caché expirado
            localStorage.removeItem('esCuba');
            localStorage.removeItem('esCuba_timestamp');
          }
        }

        // 2. Llamada a API FUNCIONAL (sin CORS issues en localhost)
        const response = await fetch('https://geolocation-db.com/json/');
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();

        // Protección: algunos proxies devuelven "Not found"
        const resultado = data.country_code === 'CU';
        const now = Date.now();

        localStorage.setItem('esCuba', String(resultado));
        localStorage.setItem('esCuba_timestamp', String(now));
        setEsCuba(resultado);
      } catch (err) {
        console.error('Error detectando país:', err);
        setErrorGeo('No se pudo detectar tu ubicación. Se mostrarán precios internacionales.');
        setEsCuba(false);

        // Guardar fallback con timestamp
        const now = Date.now();
        localStorage.setItem('esCuba', 'false');
        localStorage.setItem('esCuba_timestamp', String(now));
      }
    };

    detectarPais();
  }, []);

  return { esCuba, errorGeo };
};